module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.reg) ? _c('div', [_vm._v(" Регистрация: " + _vm._s(_vm.formatDate(_vm.reg.regDate)))]) : _vm._e(), _vm._v("\n\n      Постановка на учет:        \n      "), (_vm.tax) ? _c('div', [_vm._v(" Налоговая служба с " + _vm._s(_vm.formatDate(_vm.tax.regDate)))]) : _vm._e(), _vm._v(" "), (_vm.pf) ? _c('div', [_vm._v(" Пенсионный фонд с " + _vm._s(_vm.formatDate(_vm.pf.regDate)))]) : _vm._e(), _vm._v(" "), (_vm.fss) ? _c('div', [_vm._v(" Фонд Социального Страхования с " + _vm._s(_vm.formatDate(_vm.fss.regDate)))]) : _vm._e()])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [(_vm.reg) ? _c('div', [_vm._v("\n      Регистрация:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.reg.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.reg.number), 'Номер:', null, 'Копировать номер'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.reg.regDate)), 'Дата регистрации:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tax) ? _c('div', [_vm._v("\n      Налоговая служба:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.tax.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.tax.inn), 'ИНН:', null, 'Копировать ИНН'), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.renderValueLink(_vm.formats.blank(_vm.tax.kpp), 'КПП:', null, 'Копировать КПП'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.tax.regDate)), 'Дата постановки на учет:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pf) ? _c('div', [_vm._v("\n      Пенсионный фонд:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.pf.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.pf.number), 'Номер:', null, 'Копировать номер'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.pf.regDate)), 'Дата постановки на учет:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fss) ? _c('div', [_vm._v("\n      Фонд Социального Страхования:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.fss.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.fss.number), 'Номер:', null, 'Копировать номер'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.fss.regDate)), 'Дата постановки на учет:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6056b035","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/CredentinalsPanel.vue
// module id = 1093
// module chunks = 1